/*
 * @author hxj
 * @description 指令trsDragFrom支持拖动指定的内容到目标容器中，考虑到目标容器为编辑器，
 * 如果使用mousedown、mouseup等事件进行拖动，则不能控制编辑器插入光标的位置；
 * 目前仅通过使用HTML5的dragstart，draggable等特性，使用浏览器的拖拽特性。
 */
angular.module('util.dragdrop', []).directive('trsDragFrom', ['processingMaterialService',
    function (processingMaterialService) {
        var nextId = 0;
        return {
            restrict: 'EA',
            scope: {
                dragStart: '&',
            },
            link: function ($scope, $element, $attrs) {
                $element.attr('draggable', true);

                var json = null;
                var uuid;

                // 为图片添加唯一标识，以便添加完图片之后，标识出来添加相应的文本信息
                $element.bind('mousedown', function (event) {
                    uuid = new Date().getTime() + '_' + ++nextId;
                    $element.find('img').attr('uuid', uuid);
                    $element.find('video').attr('uuid', uuid);
                });

                $element.bind('dragstart', function (event) {
                    $element.addClass('drag-el-active');
                    json = $scope.dragStart();

                    if (json.value.FILETYPE === '2') {
                    	if(json.value.SRCIMGURL){
                    		var srcImgUrlArray = json.value.SRCIMGURL.split('/');
	                        if (srcImgUrlArray[srcImgUrlArray.length - 1].indexOf('_600.') > 0) {
	                            srcImgUrlArray[srcImgUrlArray.length - 1] = srcImgUrlArray[srcImgUrlArray.length - 1].replace(/_600./g, '.');
	                            json.value.SRCIMGURL = srcImgUrlArray.join('/');
	                        }
	                        event.originalEvent.dataTransfer.setData('Image', json.value.SRCIMGURL);
                    	}
                    } else if (json.value.FILETYPE === '1') {
                        event.originalEvent.dataTransfer.setData('text/html', json.value.HTMLCONTENT || '');
                    } else if (json.value.FILETYPE === '4') {
                        event.originalEvent.dataTransfer.setData('Text', json.value.HTMLCONTENT || '');
                    } else {
                        event.originalEvent.dataTransfer.setData('Video', json.value.videoUrl || '');
                    }
                });

                /**
                 * [notifyEditorChange description]
                 * @return  {[type]}  [return description]
                 */
                function notifyEditorChange() {
                    if (!window.UE) {
                        return;
                    }
                    var ue = window.UE.getEditor('ueditor');
                    ue.fireEvent('contentChange');
                }

                /**
                 * [adjustWidth description] 适应图片宽
                 * @param   {[object]}  dom  [dom description] dom节点
                 * @return  {[type]}         [return description]
                 */
                function adjustWidth(dom){
                    var maxImageWidth = UE.getEditor('ueditor').options.initialFrameWidth - 40; // 当前分辨率下编辑器最大宽度
                    if (parseInt(dom.offsetWidth, 10) > maxImageWidth) {
                        dom.style.width = maxImageWidth + 'px';
                        dom.width = maxImageWidth;
                        notifyEditorChange();
                    } else {
                        dom.src = json.value.SRCIMGURL || json.value.videoUrl;
                        dom.onload = function () {
                            if (this.width > maxImageWidth) {
                                dom.style.width = maxImageWidth + 'px';
                                dom.width = maxImageWidth;
                            }
                        };
                        notifyEditorChange(); // 兼容微信编辑器压缩图片
                    }
                }

                $element.bind('dragend', function (event) {
                    $element.removeClass('drag-el-active');

                    var ue = UE.getEditor('ueditor');

                    if (!ue) {
                        return;
                    }

                    var dom = ue.document.querySelector("[uuid='" + uuid + "']");

                    if (!dom) {
                        return;
                    }
                    dom.removeAttribute('uuid');
                    dom.removeAttribute('ng-src');
                    if (json.value.FILETYPE == '1') { // 文字
                        notifyEditorChange();
                        return;
                    } else if (json.value.FILETYPE === '2') { // 图片
                    	if($element.find('.img-content').length>0){
                    		var sHtml = $element.find('.img-content').attr('title');
	                        if (sHtml !== '') {
	                            sHtml = sHtml.replace(/\n/g, '<br />');
	                            sHtml = '<div>' + sHtml + '</div>';
	                            dom.insertAdjacentHTML('afterEnd', sHtml);
	                        }
	                        if (json.value.IMGNAME && json.value.IMGNAME.indexOf('/') < 0) {
	                            dom.setAttribute('oldsrc', json.value.IMGNAME);
	                        }
	                        dom.insertAdjacentHTML('beforeBegin', '<p style="text-align:center;"></p>');
	                        var imgBox = dom.previousSibling;
	                        imgBox.appendChild(dom);
	                        // 由于Ueditor会在外层p标签后自动加上换行符，导致插入的新节点后会多一行，此处进行过滤
	                        if (imgBox.nextSibling && UE.dom.domUtils.isBr(imgBox.nextSibling)) {
	                            imgBox.nextSibling.remove();
	                        }
	                        adjustWidth(dom);
                    	}
                    } else {
                        // 音视频 （可以与图片逻辑公用但是为了解耦还是分凯）
                        var audioVideoImg = document.createElement('div'); // 为了跟音视频插入报纸一致，这里也使用图片弹窗播放
                        audioVideoImg.innerHTML = processingMaterialService.editVideoOrAudio([json.value]);
                        dom.insertAdjacentHTML('beforeBegin', '<div></div>');
                        var videoBox = dom.previousSibling;
                        videoBox.appendChild(audioVideoImg);
                        var parent = dom.parentElement;
                        parent.removeChild(dom); // 跟图片不同的是视频这块需要将图片转为带视频信息的图片所以需要将原来图片移出
                        adjustWidth(audioVideoImg.getElementsByTagName('img')[0]);
                    }
                });
            },
        };
    },
]);
